import React from 'react';
import { Main } from './components';

export const Locations: React.FC = () => {
  return (
    <>
      <Main />
    </>
  );
};

export default Locations; 